import "./TheBlueprint.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ThePhilosophyOfForce from "./sections/ThePhilosophyOfForce";
import The4StepEvolution from "./sections/The4StepEvolution";
import CommonQuestions from "./sections/CommonQuestions";
import TheBasecamp from "@/reusable_sections/Footer";
export default function TheBlueprintPage() {
  return <div>
      <MainNavigation />
      <ThePhilosophyOfForce />
      <The4StepEvolution />
      <CommonQuestions />
      <TheBasecamp />
    </div>;
}